module.exports = __webpack_public_path__ + "img/home-block-3-3.b88464d6.jpg";